import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'unsaved-changes-dialog',
    templateUrl: './unsaved-changes-dialog.component.html',
    styleUrls: ['./unsaved-changes-dialog.component.scss'],
    standalone: false
})
export class UnsavedChangesDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<UnsavedChangesDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    closeDialog(): void {
        // Pass the undefined back to the parent component
        this.dialogRef.close({ continue: false });
    }

    continue(): void {
        // Pass the new node back to the parent component
        this.dialogRef.close({ continue: true });
    }
}